// Libraries
import { Box, Card, Text } from '@chakra-ui/react';
// Components
import { Spinner } from '@atoms/index';
import { BarChart } from '@molecules/index';
// Utils
import text from '@translations/en.json';
// Types
import { CiiBarChartCardProps } from './CiiBarChartCard.types';

/**
 * A card component displaying the CII Vessel Summary.
 *
 * @component
 * @param {CiiBarChartCardProps} props - The props for the CiiSummaryCard component.
 * @param {boolean} props.isLoading - Indicates whether the data is loading.
 * @param {CiiSummaryData} props.data - The data for the CII Vessel Summary.
 * @returns {ReactElement} The CiiSummaryCard component.
 */
export const CiiBarChartCard = ({ isLoading, data }: CiiBarChartCardProps) => (
  <Card width='full' p={4}>
    <Box mb={4} alignItems='center'>
      <Text fontSize={{ base: 'md', lg: 'xl' }} fontWeight='semibold'>
        {text.cii_rating_vs_forecasted_headline}
      </Text>
      <Text fontSize={{ base: 'xs', lg: 's' }} variant='faded'>
        {text.cii_rating_vs_forecasted_text}
      </Text>
    </Box>
    {isLoading && <Spinner minH={40} size='xl' />}
    {!isLoading && !!data && <BarChart barChartData={data} />}
  </Card>
);
